export default function getTaxSubtotal(tax, type) {
  return tax.filter(tax => tax.name === type).reduce((a, b) => a + b.total, 0)
}
